<div
  class="gonvarri-download-order"
>
  <img
    src="/images/pdf.svg"
    class="gonvarri-download-order__button"
    (click)="downloadOrderPdf()"
  />
</div>
